import React from 'react';
import numeral from 'numeral';

export default function PriceDisplay(props) {
  const { event, price, isUserFree = false } = props;

  // TODO: 将来的にはユーザーの場合のみ無料にする
  return <span>{isUserFree ? 'ユーザー無料' : price === 0 ? '無料' : `${numeral(price).format('0,0')}円(税込)`}</span>;
}
